const { encode, decode } = require("url-encode-decode");

// TODO Is this needed anymore?

export function convertEntitiesToChars(str: string): string {
  return decode(str);
}
